import { DocumentTypes } from "./constants";

const units = ['bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

const convertMimeTypeToDocumentType = (mimeType) => {
    switch (mimeType) {
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return DocumentTypes.Word;
        case 'text/csv':
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return DocumentTypes.Excel;
        case 'application/pdf':
            return DocumentTypes.PDF;
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
            return DocumentTypes.Image;
        case 'video/mp4':
        case 'video/mpeg':
        case 'video/x-msvideo':
            return DocumentTypes.Video;
        case 'application/xml':
        case 'text/plain':
            return DocumentTypes.Text;
        case 'application/vnd.ms-outlook':
        case 'message/rfc822':
            return DocumentTypes.OutlookItem;
        default:
            return -1;
    }
};

const niceBytes = (x) => {

  let l = 0, n = parseInt(x, 10) || 0;

  while(n >= 1024 && ++l){
      n = n/1024;
  }
  
  return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
};

export {
    convertMimeTypeToDocumentType,
    niceBytes,
    units
};